/**
 * Detect whether we're running inside Electron.
 */
export const isElectron = typeof window !== 'undefined' && !!window.electronAPI;

/**
 * Get the electronAPI bridge (null when running in browser).
 */
export function getElectronAPI() {
  if (isElectron) {
    return window.electronAPI;
  }
  return null;
}
